import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Header } from 'foundations-components/transitional/components/Header';
import { Text } from 'foundations-components/components/Text';
import UIBreadcrumbs from 'UIComponents/nav/UIBreadcrumbs';
import UILink from 'UIComponents/link/UILink';
import { useLocation, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { TEAMS } from '../../constants/OverviewConstants';
import { getFormattedName, getPermissionedOwnerFromURL } from '../../utils/userUtils';
import { getLastSavedTeam } from '../../utils/filters';
import Tabs from '../tabs/Tabs.tsx';
import HeaderButtons from './HeaderButtons';
import { setDetailViewOwner } from '../../actions/DetailViewActions';
import { getIsUngatedToAIProjections } from '../../selectors/authSelectors';
import { getOwnerIdToUserIdMap, getOwnerIdsWithPermissions, getOwnersMap } from '../../selectors/ownersSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RepDetailForecastHeader = () => {
  const history = useHistory();
  const location = useLocation();
  const isUngatedToAIProjections = useSelector(getIsUngatedToAIProjections);
  const ownerIdToUserIdMap = useSelector(getOwnerIdToUserIdMap);
  const ownerIdsWithPermissions = useSelector(getOwnerIdsWithPermissions);
  const owners = useSelector(getOwnersMap);
  const owner = getPermissionedOwnerFromURL(location, ownerIdToUserIdMap, ownerIdsWithPermissions, owners);
  const title = owner ? getFormattedName(owner) : '';
  const titleSuffix = !(owner !== null && owner !== void 0 && owner.get('isActive')) ? ` ${I18n.text('repDetail.deactivatedUserLabel')}` : undefined;
  const lastTeamId = getLastSavedTeam();
  return /*#__PURE__*/_jsx(Header, {
    use: "condensed",
    flush: true,
    breadcrumbs:
    /*#__PURE__*/
    // TODO: replace UILink with `Button` from foundations-components when the link styling is ready
    // https://git.hubteam.com/HubSpot/forecasting-team/issues/2409
    _jsx(UIBreadcrumbs, {
      className: "m-top-0 p-x-0",
      children: /*#__PURE__*/_jsx(UILink, {
        onClick: () => {
          setDetailViewOwner(null);
          history.push(lastTeamId ? `/${TEAMS}/${lastTeamId}` : `/${TEAMS}`);
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          "data-test-id": "back-to-forecast",
          message: "repDetail.backButton"
        })
      })
    }),
    title: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "span",
        typography: "heading-300",
        children: title
      }), titleSuffix && /*#__PURE__*/_jsx(Text, {
        as: "span",
        typography: "body-400",
        children: titleSuffix
      })]
    }),
    tabs: isUngatedToAIProjections && /*#__PURE__*/_jsx(Tabs, {
      isDetail: true
    }),
    children: /*#__PURE__*/_jsx(HeaderButtons, {
      isDetail: true
    })
  });
};
const ForecastHeader = ({
  isDetail
}) => {
  const isUngatedToAIProjections = useSelector(getIsUngatedToAIProjections);
  if (isDetail) {
    return /*#__PURE__*/_jsx(RepDetailForecastHeader, {});
  }
  return /*#__PURE__*/_jsx(Header, {
    use: "condensed",
    flush: true,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "index.header.title"
    }),
    tabs: isUngatedToAIProjections && /*#__PURE__*/_jsx(Tabs, {
      isDetail: false
    }),
    children: /*#__PURE__*/_jsx(HeaderButtons, {
      isDetail: false
    })
  });
};
export default ForecastHeader;